define("shared/errors/api-not-found-error", ["exports", "@ember/error"], function (_exports, _error) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/error"eaimeta@70e063a35619d71f
  function APINotFoundError(error) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'API not found';
    _error.default.call(this, message);
    this.errors = [error] || [{
      title: 'API Not Found',
      detail: message,
      code: error.code,
      scopes: []
    }];
  }
  APINotFoundError.prototype = Object.create(_error.default.prototype);
  var _default = _exports.default = APINotFoundError;
});